import products from './products';
import canonical from './canonical';
import whatsHappening from './whats-happening';
export { completelyCanonicalUrl } from './completely-canonical-url';
const canonicalLink = {
  products,
  canonical,
  whatsHappening
};
export default canonicalLink;